module.exports = __webpack_public_path__ + "img/L_299_0.df9fa0b9.png";